var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('modal',{on:{"close":_vm.handleClickClose}},[[_c('call-user-select')]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }